import { addMessages } from '@hana/i18n';

// Chuỗi giao diện Tệp (Mint-Files). Tên tệp, mã người dùng, dữ liệu mẫu không dịch.
addMessages('vi', {
  'fl.noWrite': 'Chưa mở ghi ở bản này',
  'fl.mine': 'Tệp của tôi',
  'fl.recent': 'Gần đây',
  'fl.shared': 'Được chia sẻ với tôi',
  'fl.myshared': 'Tôi đã chia sẻ',
  'fl.large': 'File lớn',
  'fl.dupes': 'File trùng',
  'fl.stale': 'Lâu không dùng',
  'fl.external': 'Chia sẻ ra ngoài',
  'fl.phMy': 'Tìm tệp, nội dung',
  'fl.phLib': 'Tìm tài liệu, nội dung PDF / Word',
  'fl.phMedia': 'Tìm album, địa điểm',
  'fl.detail': 'Chi tiết',
  'fl.pickDoc': 'Chọn một tài liệu để xem tóm tắt, phiên bản và bình luận.',
  'fl.pickFile': 'Chọn một tệp để xem trước, phiên bản và quyền.',
  'fl.thisFolder': 'Thư mục này',
  'fl.folder': 'Thư mục',
  'fl.items': 'Số mục',
  'fl.size': 'Dung lượng',
  'fl.lastEdit': 'Sửa gần nhất',
  'fl.askSum': 'Ask HANA tóm tắt thư mục',
  'fl.title': 'Tệp & tài liệu',
  'fl.groups': 'Nhóm tệp',
  'fl.tabMy': 'Tệp của tôi OneDrive',
  'fl.tabLib': 'Tài liệu công ty',
  'fl.tabMedia': 'Media',
  'fl.density': 'Mật độ',
  'fl.dStd': 'Chuẩn',
  'fl.dDense': 'Gọn',
  'fl.notif3': 'Thông báo, 3 chưa đọc',
  'fl.detailPanel': 'Bảng chi tiết',
  'fl.upload': 'Tải lên',
  'fl.addDoc': 'Thêm tài liệu',
  'fl.uploadPhoto': 'Tải ảnh lên',
  'fl.newAlbum': 'Tạo album',
  'fl.oneDriveDirs': 'Thư mục OneDrive',
  'fl.pinned': 'GHIM',
  'fl.clean': 'DỌN DẸP',
  'fl.quota': 'Dung lượng',
  'fl.quotaAria': 'Dung lượng OneDrive',
  'fl.quotaSub': 'Đã dùng 79% · nhiều nhất là video và ảnh',
  'fl.trashOd': 'Thùng rác OneDrive',
  'fl.openOd': 'Mở OneDrive trên web',
  'fl.empOd': 'OneDrive nhân viên',
  'fl.admin': 'Admin',
  'fl.list': 'Danh sách tệp',
  'fl.new': 'Mới ▾',
  'fl.up': 'Lên một cấp',
  'fl.refresh': 'Làm mới',
  'fl.path': 'Đường dẫn',
  'fl.filter': 'Lọc',
  'fl.layout': 'Kiểu xem',
  'fl.grid': 'Lưới',
  'fl.errTitle': 'Không kết nối được OneDrive',
  'fl.npTitle': 'HANA Ezy chưa được cấp quyền OneDrive',
  'fl.emptyDir': 'Thư mục trống',
  'fl.errDesc': 'Phiên đăng nhập Microsoft hết hạn lúc 09:02. Tệp chưa tải hết vẫn ở hàng đợi, sẽ chạy lại khi kết nối.',
  'fl.npDesc': 'Cần đồng ý quyền Files.ReadWrite cho tài khoản Microsoft của bạn. Thư viện tài liệu công ty và Media vẫn dùng bình thường.',
  'fl.reconnect': 'Kết nối lại',
  'fl.grant': 'Cấp quyền OneDrive',
  'fl.quick': 'TRUY CẬP NHANH',
  'fl.selAll': 'Chọn tất cả',
  'fl.colName': 'Tên',
  'fl.colEdited': 'Sửa lúc',
  'fl.colBy': 'Người sửa',
  'fl.colType': 'Loại',
  'fl.colSize': 'Dung lượng',
  'fl.noMatch': 'Không có tệp khớp',
  'fl.dir': 'Thư mục',
  'fl.select': 'Chọn {n}',
  'fl.anyone': 'Ai có link',
  'fl.org': 'Trong công ty',
  'fl.pinTx': '· đã ghim',
  'fl.txtHit': 'Khớp nội dung: …{s}…',
  'fl.sharedBy': 'Chia sẻ bởi {n}',
  'fl.itemsN': '{n} mục',
  'fl.actWith': 'Thao tác với {n}',
  'fl.chosen': 'Đã chọn {n}',
  'fl.itemsFoot': '{n} mục',
  // Tài liệu công ty
  'fl.lib.notice': '{n} thư nhãn NOTICE mới trong info@ có tệp đính kèm chưa nhập.',
  'fl.lib.noticeSub': ' Hệ thống chỉ nhắc, bạn chọn tệp nào vào thư viện.',
  'fl.lib.scan': 'Quét mail',
  'fl.lib.hide': 'Ẩn nhắc',
  'fl.lib.left': 'còn {n} ngày',
  'fl.lib.until': 'đến {d}',
  'fl.lib.typeDom': 'Loại văn bản và nghiệp vụ',
  'fl.lib.fType': 'Loại: {v}',
  'fl.lib.fDom': 'Nghiệp vụ: {v}',
  'fl.lib.all': 'Tất cả tài liệu',
  'fl.lib.trash60': 'Thùng rác · 60 ngày',
  'fl.lib.hType': 'LOẠI VĂN BẢN',
  'fl.lib.hDom': 'NGHIỆP VỤ',
  'fl.lib.docList': 'Danh sách tài liệu',
  'fl.lib.trash': 'Thùng rác',
  'fl.lib.docsN': '{n} tài liệu',
  'fl.lib.autoDel': ' · tự xoá hẳn sau 60 ngày',
  'fl.lib.unfilter': 'Bỏ lọc {v}',
  'fl.lib.bulk': 'Thao tác hàng loạt',
  'fl.lib.restore': 'Khôi phục',
  'fl.lib.download': 'Tải về',
  'fl.lib.delForever': 'Xoá hẳn',
  'fl.lib.delTrash': 'Xoá vào thùng rác',
  'fl.lib.unselect': 'Bỏ chọn',
  'fl.lib.errTitle': 'Không tải được thư viện tài liệu',
  'fl.lib.trashEmpty': 'Thùng rác trống',
  'fl.lib.none': 'Chưa có tài liệu',
  'fl.lib.errDesc': 'Thư viện SharePoint không phản hồi lúc 09:02. Bản tải về trước đó vẫn mở được trong trình xem.',
  'fl.lib.trashDesc': 'Tài liệu xoá sẽ nằm đây 60 ngày.',
  'fl.lib.noneDesc': 'Thêm tài liệu từ máy, link ngoài, mail info@ hoặc eCoSys.',
  'fl.lib.retry': 'Thử lại',
  'fl.lib.viewOnly': 'Chỉ xem.',
  'fl.lib.colDoc': 'Tài liệu',
  'fl.lib.colType': 'Loại văn bản',
  'fl.lib.colDom': 'Nghiệp vụ',
  'fl.lib.colLeft': 'Còn lại',
  'fl.lib.colEff': 'Hiệu lực',
  'fl.lib.colVer': 'Bản',
  'fl.lib.delBy': 'Xoá bởi {n}',
  'fl.lib.locked': 'Đã khoá',
  'fl.lib.comments': '· {n} bình luận',
  'fl.lib.noDocMatch': 'Không có tài liệu khớp “{q}” trong tên, tóm tắt hay nội dung PDF / Word.',
  'fl.lib.closePanel': 'Đóng bảng chi tiết',
  'fl.lib.lock': 'Khoá',
  'fl.lib.view': 'Xem',
  'fl.lib.actions': 'Thao tác ▾',
  'fl.lib.aiSum': 'Tóm tắt của HANA',
  'fl.lib.versions': 'Phiên bản',
  'fl.lib.current': ' · hiện tại',
  'fl.lib.commentsN': 'Bình luận ({n})',
  'fl.lib.kEff': 'Hiệu lực',
  'fl.lib.kExp': 'Hết hạn',
  'fl.lib.kSrc': 'Nguồn',
  'fl.lib.kBy': 'Tải lên bởi',
  'fl.lib.kViews': 'Lượt xem',
  'fl.lib.kVer': 'Phiên bản',
  'fl.lib.noExp': 'không có',
  // Media
  'fl.md.thisMonth': 'Tháng này',
  'fl.md.3m': '3 tháng',
  'fl.md.year': 'Năm nay',
  'fl.md.all': 'Tất cả',
  'fl.md.nav': 'Bảng tin và album',
  'fl.md.feed': 'Bảng tin',
  'fl.md.album': 'Album',
  'fl.md.dateFilter': 'LỌC NGÀY',
  'fl.md.lbBtn': 'Bảng xếp hạng ảnh',
  'fl.md.lbTitle': 'Bảng xếp hạng ảnh · năm 2026',
  'fl.md.lbDesc': 'Điểm = số ảnh được giữ × điểm AI trung bình + lượt thích.',
  'fl.md.close': 'Đóng',
  'fl.md.export': 'Xuất Excel',
  'fl.md.thContrib': 'Người đóng góp',
  'fl.md.thPhoto': 'Ảnh',
  'fl.md.thAi': 'AI TB',
  'fl.md.thScore': 'Điểm',
  'fl.md.back': 'Về danh sách album',
  'fl.md.missingDL': 'thiếu ngày và địa điểm',
  'fl.md.photosShown': '{n} ảnh hiện',
  'fl.md.albumsN': '{n} album',
  'fl.md.pickN': 'Đã chọn {n}',
  'fl.md.cover': 'Đặt ảnh bìa',
  'fl.md.origDl': 'Tải ảnh gốc',
  'fl.md.delPhoto': 'Xoá ảnh',
  'fl.md.how': 'Cách xem',
  'fl.md.grid': 'Lưới album',
  'fl.md.errTitle': 'Không tải được album',
  'fl.md.emptyTitle': 'Chưa có album trong khoảng ngày này',
  'fl.md.errDesc': 'Ảnh đã tải lên vẫn an toàn trên SharePoint. Thử lại sau ít phút.',
  'fl.md.emptyDesc': 'Tạo album cho sự kiện, ghi ngày và địa điểm rồi tải ảnh lên.',
  'fl.md.added': 'đã thêm {n} ảnh vào',
  'fl.md.noDateLoc': 'Thiếu ngày và địa điểm',
  'fl.md.openAlbum': 'Mở album {n}',
  'fl.md.like': 'Thích · {n}',
  'fl.md.commentsN': '{n} bình luận',
  'fl.md.photosVideos': '{p} ảnh · {v} video',
  'fl.md.likesN': '{n} thích',
  'fl.md.missingA': 'Album thiếu {v}.',
  'fl.md.missingB': ' Sửa album trước khi tải ảnh lên.',
  'fl.md.evDate': 'ngày sự kiện',
  'fl.md.place': 'địa điểm',
  'fl.md.and': ' và ',
  'fl.md.pickPhoto': 'Chọn ảnh {n}',
  'fl.md.cvr': 'Ảnh bìa',
  'fl.md.pickAlbum': 'Chọn một album để xem ảnh, bình luận và thông tin.',
  'fl.md.activity': 'Hoạt động',
  'fl.md.markRead': 'Đánh dấu đã đọc hết',
  'fl.md.uploadP': 'Tải ảnh',
  'fl.md.edit': 'Sửa',
  'fl.md.del': 'Xoá',
  'fl.md.comments': 'Bình luận',
  'fl.md.kDate': 'Ngày',
  'fl.md.kLoc': 'Địa điểm',
  'fl.md.kDesc': 'Mô tả',
  'fl.md.kCount': 'Số lượng',
  'fl.md.kBy': 'Tạo bởi',
  'fl.md.none': 'chưa có',
});
addMessages('en', {
  'fl.noWrite': 'Writing is not enabled in this version',
  'fl.mine': 'My files',
  'fl.recent': 'Recent',
  'fl.shared': 'Shared with me',
  'fl.myshared': 'Shared by me',
  'fl.large': 'Large files',
  'fl.dupes': 'Duplicate files',
  'fl.stale': 'Not used for a while',
  'fl.external': 'Shared externally',
  'fl.phMy': 'Search files, content',
  'fl.phLib': 'Search documents, PDF / Word content',
  'fl.phMedia': 'Search albums, places',
  'fl.detail': 'Details',
  'fl.pickDoc': 'Select a document to see its summary, versions and comments.',
  'fl.pickFile': 'Select a file to see its preview, versions and permissions.',
  'fl.thisFolder': 'This folder',
  'fl.folder': 'Folder',
  'fl.items': 'Items',
  'fl.size': 'Size',
  'fl.lastEdit': 'Last edited',
  'fl.askSum': 'Ask HANA to summarise this folder',
  'fl.title': 'Files & documents',
  'fl.groups': 'File groups',
  'fl.tabMy': 'My files OneDrive',
  'fl.tabLib': 'Company documents',
  'fl.tabMedia': 'Media',
  'fl.density': 'Density',
  'fl.dStd': 'Standard',
  'fl.dDense': 'Compact',
  'fl.notif3': 'Notifications, 3 unread',
  'fl.detailPanel': 'Details panel',
  'fl.upload': 'Upload',
  'fl.addDoc': 'Add document',
  'fl.uploadPhoto': 'Upload photos',
  'fl.newAlbum': 'New album',
  'fl.oneDriveDirs': 'OneDrive folders',
  'fl.pinned': 'PINNED',
  'fl.clean': 'CLEAN-UP',
  'fl.quota': 'Storage',
  'fl.quotaAria': 'OneDrive storage',
  'fl.quotaSub': '79% used · mostly videos and photos',
  'fl.trashOd': 'OneDrive recycle bin',
  'fl.openOd': 'Open OneDrive on the web',
  'fl.empOd': 'Staff OneDrive',
  'fl.admin': 'Admin',
  'fl.list': 'File list',
  'fl.new': 'New ▾',
  'fl.up': 'Up one level',
  'fl.refresh': 'Refresh',
  'fl.path': 'Path',
  'fl.filter': 'Filter',
  'fl.layout': 'View mode',
  'fl.grid': 'Grid',
  'fl.errTitle': 'Cannot connect to OneDrive',
  'fl.npTitle': 'HANA Ezy has not been granted OneDrive access',
  'fl.emptyDir': 'Empty folder',
  'fl.errDesc': 'Your Microsoft sign-in expired at 09:02. Unfinished uploads stay in the queue and resume once reconnected.',
  'fl.npDesc': 'Consent to the Files.ReadWrite permission for your Microsoft account. The company library and Media still work normally.',
  'fl.reconnect': 'Reconnect',
  'fl.grant': 'Grant OneDrive access',
  'fl.quick': 'QUICK ACCESS',
  'fl.selAll': 'Select all',
  'fl.colName': 'Name',
  'fl.colEdited': 'Modified',
  'fl.colBy': 'Modified by',
  'fl.colType': 'Type',
  'fl.colSize': 'Size',
  'fl.noMatch': 'No matching files',
  'fl.dir': 'Folder',
  'fl.select': 'Select {n}',
  'fl.anyone': 'Anyone with link',
  'fl.org': 'Company only',
  'fl.pinTx': '· pinned',
  'fl.txtHit': 'Content match: …{s}…',
  'fl.sharedBy': 'Shared by {n}',
  'fl.itemsN': '{n} items',
  'fl.actWith': 'Actions for {n}',
  'fl.chosen': '{n} selected',
  'fl.itemsFoot': '{n} items',
  'fl.lib.notice': '{n} new NOTICE mails in info@ have attachments not yet imported.',
  'fl.lib.noticeSub': ' The system only reminds you; you choose which files go into the library.',
  'fl.lib.scan': 'Scan mail',
  'fl.lib.hide': 'Hide reminder',
  'fl.lib.left': '{n} days left',
  'fl.lib.until': 'until {d}',
  'fl.lib.typeDom': 'Document type and business area',
  'fl.lib.fType': 'Type: {v}',
  'fl.lib.fDom': 'Area: {v}',
  'fl.lib.all': 'All documents',
  'fl.lib.trash60': 'Recycle bin · 60 days',
  'fl.lib.hType': 'DOCUMENT TYPE',
  'fl.lib.hDom': 'BUSINESS AREA',
  'fl.lib.docList': 'Document list',
  'fl.lib.trash': 'Recycle bin',
  'fl.lib.docsN': '{n} documents',
  'fl.lib.autoDel': ' · permanently deleted after 60 days',
  'fl.lib.unfilter': 'Remove filter {v}',
  'fl.lib.bulk': 'Bulk actions',
  'fl.lib.restore': 'Restore',
  'fl.lib.download': 'Download',
  'fl.lib.delForever': 'Delete permanently',
  'fl.lib.delTrash': 'Move to recycle bin',
  'fl.lib.unselect': 'Clear selection',
  'fl.lib.errTitle': 'Cannot load the document library',
  'fl.lib.trashEmpty': 'Recycle bin is empty',
  'fl.lib.none': 'No documents yet',
  'fl.lib.errDesc': 'The SharePoint library did not respond at 09:02. Previously downloaded copies still open in the viewer.',
  'fl.lib.trashDesc': 'Deleted documents stay here for 60 days.',
  'fl.lib.noneDesc': 'Add documents from your computer, an external link, the info@ mailbox or eCoSys.',
  'fl.lib.retry': 'Retry',
  'fl.lib.viewOnly': 'View only.',
  'fl.lib.colDoc': 'Document',
  'fl.lib.colType': 'Document type',
  'fl.lib.colDom': 'Business area',
  'fl.lib.colLeft': 'Remaining',
  'fl.lib.colEff': 'Effective',
  'fl.lib.colVer': 'Ver.',
  'fl.lib.delBy': 'Deleted by {n}',
  'fl.lib.locked': 'Locked',
  'fl.lib.comments': '· {n} comments',
  'fl.lib.noDocMatch': 'No document matches “{q}” in title, summary or PDF / Word content.',
  'fl.lib.closePanel': 'Close details panel',
  'fl.lib.lock': 'Locked',
  'fl.lib.view': 'View',
  'fl.lib.actions': 'Actions ▾',
  'fl.lib.aiSum': 'HANA summary',
  'fl.lib.versions': 'Versions',
  'fl.lib.current': ' · current',
  'fl.lib.commentsN': 'Comments ({n})',
  'fl.lib.kEff': 'Effective',
  'fl.lib.kExp': 'Expires',
  'fl.lib.kSrc': 'Source',
  'fl.lib.kBy': 'Uploaded by',
  'fl.lib.kViews': 'Views',
  'fl.lib.kVer': 'Version',
  'fl.lib.noExp': 'none',
  'fl.md.thisMonth': 'This month',
  'fl.md.3m': '3 months',
  'fl.md.year': 'This year',
  'fl.md.all': 'All',
  'fl.md.nav': 'Feed and albums',
  'fl.md.feed': 'Feed',
  'fl.md.album': 'Albums',
  'fl.md.dateFilter': 'DATE FILTER',
  'fl.md.lbBtn': 'Photo leaderboard',
  'fl.md.lbTitle': 'Photo leaderboard · 2026',
  'fl.md.lbDesc': 'Score = photos kept × average AI score + likes.',
  'fl.md.close': 'Close',
  'fl.md.export': 'Export Excel',
  'fl.md.thContrib': 'Contributor',
  'fl.md.thPhoto': 'Photos',
  'fl.md.thAi': 'Avg AI',
  'fl.md.thScore': 'Score',
  'fl.md.back': 'Back to album list',
  'fl.md.missingDL': 'missing date and place',
  'fl.md.photosShown': '{n} photos shown',
  'fl.md.albumsN': '{n} albums',
  'fl.md.pickN': '{n} selected',
  'fl.md.cover': 'Set as cover',
  'fl.md.origDl': 'Download originals',
  'fl.md.delPhoto': 'Delete photos',
  'fl.md.how': 'View mode',
  'fl.md.grid': 'Album grid',
  'fl.md.errTitle': 'Cannot load albums',
  'fl.md.emptyTitle': 'No albums in this date range',
  'fl.md.errDesc': 'Uploaded photos are still safe on SharePoint. Try again in a few minutes.',
  'fl.md.emptyDesc': 'Create an album for the event, enter the date and place, then upload photos.',
  'fl.md.added': 'added {n} photos to',
  'fl.md.noDateLoc': 'Missing date and place',
  'fl.md.openAlbum': 'Open album {n}',
  'fl.md.like': 'Like · {n}',
  'fl.md.commentsN': '{n} comments',
  'fl.md.photosVideos': '{p} photos · {v} videos',
  'fl.md.likesN': '{n} likes',
  'fl.md.missingA': 'Album is missing {v}.',
  'fl.md.missingB': ' Edit the album before uploading photos.',
  'fl.md.evDate': 'event date',
  'fl.md.place': 'place',
  'fl.md.and': ' and ',
  'fl.md.pickPhoto': 'Select photo {n}',
  'fl.md.cvr': 'Cover',
  'fl.md.pickAlbum': 'Select an album to see photos, comments and info.',
  'fl.md.activity': 'Activity',
  'fl.md.markRead': 'Mark all as read',
  'fl.md.uploadP': 'Upload photos',
  'fl.md.edit': 'Edit',
  'fl.md.del': 'Delete',
  'fl.md.comments': 'Comments',
  'fl.md.kDate': 'Date',
  'fl.md.kLoc': 'Place',
  'fl.md.kDesc': 'Description',
  'fl.md.kCount': 'Count',
  'fl.md.kBy': 'Created by',
  'fl.md.none': 'not set',
});
addMessages('vi', { 'fl.kImg': 'Ảnh', 'fl.kFile': 'Tệp' });
addMessages('en', { 'fl.kImg': 'Image', 'fl.kFile': 'File' });
addMessages('vi', {
  'fl.ph.mine': 'Của tôi', 'fl.ph.shared': 'Được chia sẻ', 'fl.ph.large': 'File lớn', 'fl.ph.external': 'Ra ngoài',
  'fl.ph.phLib': 'Tìm tài liệu, nội dung', 'fl.ph.phMedia': 'Tìm album',
  'fl.ph.subDir': '{n} mục · {d}', 'fl.ph.subOwner': '{o} chia sẻ · {d}', 'fl.ph.anyone': '{s} · ai có link', 'fl.ph.org': ' · trong công ty',
  'fl.ph.albumSub': '{d} · {l} · {p} ảnh',
  'fl.ph.store': 'Kho tệp', 'fl.ph.tabMy': 'Của tôi', 'fl.ph.tabLib': 'Tài liệu', 'fl.ph.search': 'Tìm tệp',
  'fl.ph.noResult': 'Không có kết quả', 'fl.ph.noFile': 'Chưa có tệp', 'fl.ph.emptyDesc': 'Bấm + để tải tệp hoặc chụp ảnh.',
  'fl.ph.npDesc': 'Thư viện công ty và Media vẫn xem được.', 'fl.ph.crumb': 'Tệp của tôi › {n}',
  'fl.ph.newAlbum': 'Tạo album hoặc tải ảnh',
});
addMessages('en', {
  'fl.ph.mine': 'Mine', 'fl.ph.shared': 'Shared', 'fl.ph.large': 'Large files', 'fl.ph.external': 'External',
  'fl.ph.phLib': 'Search documents, content', 'fl.ph.phMedia': 'Search albums',
  'fl.ph.subDir': '{n} items · {d}', 'fl.ph.subOwner': 'Shared by {o} · {d}', 'fl.ph.anyone': '{s} · anyone with link', 'fl.ph.org': ' · company only',
  'fl.ph.albumSub': '{d} · {l} · {p} photos',
  'fl.ph.store': 'File store', 'fl.ph.tabMy': 'Mine', 'fl.ph.tabLib': 'Documents', 'fl.ph.search': 'Search files',
  'fl.ph.noResult': 'No results', 'fl.ph.noFile': 'No files yet', 'fl.ph.emptyDesc': 'Tap + to upload a file or take a photo.',
  'fl.ph.npDesc': 'The company library and Media are still available.', 'fl.ph.crumb': 'My files › {n}',
  'fl.ph.newAlbum': 'New album or upload photos',
});

// Xem tệp (Mint-FileViewer): trình xem, PDF Editor, ký / đóng dấu, điện thoại.
addMessages('vi', {
  'fv.cancel': 'Huỷ',
  'fv.signBar': 'Ký / đóng dấu · trang {n}',
  'fv.signApply': 'Áp dụng chữ ký',
  'fv.signPosOf': 'Vị trí {x}',
  'fv.signSurr': 'dấu SURRENDERED',
  'fv.signSig': 'chữ ký',
  'fv.signDir': 'Giám đốc · PHILIP',
  'fv.signedOn': 'ký 22/10/2026',
  'fv.rightCol': 'Cột phải',
  'fv.signTitle': 'Ký / đóng dấu PDF',
  'fv.signKind': 'Loại chữ ký',
  'fv.sg.mine.l': 'Chữ ký của tôi',
  'fv.sg.mine.v': 'Ảnh chữ ký lưu trên máy này · bấm là ký',
  'fv.sg.ceo.l': 'Mộc công ty + chữ ký Giám đốc',
  'fv.sg.ceo.v': 'Theo quyền được cấp · ghi nhật ký',
  'fv.sg.surr.l': 'Dấu SURRENDERED',
  'fv.sg.surr.v': 'Cho B/L surrender · tạo tại chỗ',
  'fv.sigSwapped': 'Đã thay ảnh chữ ký · lưu trên máy này',
  'fv.sigSwap': 'Đổi ảnh chữ ký · nền trắng tự xoá',
  'fv.page': 'Trang',
  'fv.position': 'Vị trí',
  'fv.pos.tl': 'Trên trái',
  'fv.pos.tc': 'Trên giữa',
  'fv.pos.tr': 'Trên phải',
  'fv.pos.bl': 'Dưới trái',
  'fv.pos.bc': 'Dưới giữa',
  'fv.pos.br': 'Dưới phải',
  'fv.size': 'Cỡ',
  'fv.sizeSig': 'Cỡ chữ ký',
  'fv.saveOut': 'Lưu ra ',
  'fv.saveBeside': ' cạnh bản gốc.',
  'fv.saveKeep': ' Bản gốc không đổi.',
  'fv.pg.bc': 'Xác nhận booking',
  'fv.pg.er': 'Lệnh cấp rỗng',
  'fv.pg.terms': 'Điều khoản',
  'fv.pg.si': 'SI',
  'fv.pg.cont': 'Container',
  'fv.pg.remarks': 'Ghi chú',
  'fv.pg.cancel': 'Thông báo huỷ',
  'fv.pg.mImg': 'Ảnh gộp',
  'fv.pg.mDrop': 'Lệnh hạ cont',
  'fv.defText': 'Đã kiểm tra · PhuongHT 22/10',
  'fv.edBar': 'PDF Editor · {n} thao tác',
  'fv.undo': 'Hoàn tác',
  'fv.edCancel': 'Huỷ sửa',
  'fv.edSave': 'Lưu bản sửa',
  'fv.leaveT': 'Bỏ {n} thao tác chưa lưu?',
  'fv.keepEd': 'Tiếp tục sửa',
  'fv.discard': 'Bỏ thay đổi',
  'fv.leaveD': 'Các thay đổi trang chưa lưu thành tệp sẽ mất. Bản gốc không bị ảnh hưởng.',
  'fv.tool.rl': 'Xoay trái',
  'fv.tool.rr': 'Xoay phải',
  'fv.tool.del': 'Xoá trang',
  'fv.tool.up': 'Lên',
  'fv.tool.down': 'Xuống',
  'fv.tool.split': 'Tách trang chọn',
  'fv.tool.merge': 'Gộp tệp',
  'fv.tool.text': 'Chèn chữ',
  'fv.tool.redact': 'Che vùng',
  'fv.op.rl': 'Xoay trái trang {p}',
  'fv.op.rr': 'Xoay phải trang {p}',
  'fv.op.del': 'Xoá trang {p}',
  'fv.op.up': 'Đưa trang {p} lên',
  'fv.op.down': 'Đưa trang {p} xuống',
  'fv.op.split': 'Đã tách trang {p} thành {f} cạnh bản gốc',
  'fv.op.redact': 'Che vùng thông tin trang {p}',
  'fv.op.text': 'Chèn chữ “{v}” vào trang {p}',
  'fv.op.merge': 'Gộp thêm {n} tệp vào cuối',
  'fv.pdfTools': 'Công cụ PDF',
  'fv.hintSel': 'Đã chọn trang {p} · bấm trang để chọn / bỏ',
  'fv.hintNone': 'Bấm trang để chọn (chọn được nhiều trang) rồi chọn công cụ.',
  'fv.textIn': 'Chèn chữ vào trang {p}',
  'fv.textVal': 'Nội dung chữ chèn',
  'fv.insert': 'Chèn',
  'fv.pageOf': 'Trang {n} · {k}',
  'fv.merged': 'gộp',
  'fv.pending': 'Thao tác chờ lưu',
  'fv.noChange': 'Chưa có thay đổi. Chọn trang rồi bấm công cụ phía trên.',
  'fv.backFiles': 'Quay lại danh sách tệp',
  'fv.loading': 'Đang tải tệp…',
  'fv.errT': 'Không mở được tệp',
  'fv.errPhone': 'Tải về để mở bằng ứng dụng.',
  'fv.nopermPhone': 'Không có quyền xem tệp chứng từ của job này.',
  'fv.phAsk': 'HANA: SI cut-off hôm nay 16:00, CY 23/Oct 11:00',
  'fv.askHana': 'Hỏi HANA',
  'fv.extract': 'Trích chữ',
  'fv.copied': 'Đã chép {n} dòng',
  'fv.copy': 'Sao chép',
  'fv.m.file': 'Tệp',
  'fv.m.send': 'Gửi',
  'fv.m.pdf': 'PDF',
  'fv.mi.dl': 'Tải về',
  'fv.mi.share': 'Chia sẻ',
  'fv.mi.link': 'Chép link',
  'fv.mi.print': 'In',
  'fv.mi.del': 'Xoá',
  'fv.mi.mailCust': 'Gửi email cho khách',
  'fv.mi.relBkg': 'Release BKG cho khách',
  'fv.mi.sign': 'Ký / đóng dấu',
  'fv.mi.pgOps': 'Xoay, xoá, sắp, tách, gộp trang',
  'fv.mi.txtOps': 'Chèn chữ, che thông tin',
  'fv.mi.ipad': 'trên iPad / máy tính',
  'fv.pageN': 'Trang {n}',
  'fv.pageFoot': '{name} · trang {no}/{total}',
  'fv.savedEd': 'Đã lưu {f} cạnh bản gốc · {n} thao tác',
  'fv.savedSign': 'Đã lưu {f} · {x} trang {p}',
  'fv.signCeo': 'mộc + chữ ký Giám đốc',
  'fv.signDavid': 'chữ ký DAVID',
  'fv.ocrImg': 'OCR ảnh',
  'fv.file': 'Tệp',
  'fv.nPhotos': '{a}/{b} ảnh',
  'fv.photo': 'Ảnh',
  'fv.uploader': 'Người tải lên',
  'fv.type': 'Loại',
  'fv.uploadedAt': 'Tải lên {at}',
  'fv.uploaderS': 'Người tải',
  'fv.aiScore': 'Điểm AI',
  'fv.typeDoc': 'Loại (TypeDoc)',
  'fv.upload': 'Tải lên',
  'fv.savedAt': 'Lưu tại',
  'fv.inMail': 'Chưa lưu · trong thư',
  'fv.jobLib': 'Thư viện chứng từ job',
  'fv.noDelete': 'Không xoá',
  'fv.yesDND': 'Có (DonotDelete)',
  'fv.no': 'Không',
  'fv.backAlbum': 'Về album',
  'fv.backMail': 'Về thư',
  'fv.backJob': 'Về chi tiết job',
  'fv.ptiAlt': 'Ảnh PTI cont WHLU 5523018',
  'fv.prev': 'Ảnh trước',
  'fv.next': 'Ảnh sau',
  'fv.film': 'Dải ảnh',
  'fv.renameT': 'Đổi tên tệp',
  'fv.saveName': 'Lưu tên',
  'fv.fileName': 'Tên tệp',
  'fv.mailT': 'Gửi tệp qua email',
  'fv.mailFrom': 'Gửi từ hộp {m}',
  'fv.send': 'Gửi',
  'fv.to': 'Tới',
  'fv.toReq': 'Nhập người nhận',
  'fv.subject': 'Tiêu đề',
  'fv.body': 'Nội dung',
  'fv.mailBody': 'Chào anh/chị,\nHANA gửi tệp đính kèm cho lô {j}.\nTrân trọng,\nDAVID · HANA Logistics',
  'fv.mergeT': 'Gộp thêm tệp vào cuối',
  'fv.mergeD': 'PDF hoặc ảnh PNG / JPG (ảnh thành một trang A4 vừa khít)',
  'fv.mergeN': 'Gộp {n} tệp',
  'fv.mgPti': 'Ảnh PTI · từ HANA Mov',
  'fv.mgDrop': 'Lệnh hạ cont · tệp của job',
  'fv.pickLocal': 'Chọn tệp từ máy…',
  'fv.viewing': 'Đang xem {f}',
  'fv.g.file': 'Tệp',
  'fv.g.send': 'Gửi',
  'fv.g.pdf': 'PDF',
  'fv.g.job': 'Job',
  'fv.mn.file.rename': 'Đổi tên',
  'fv.mn.file.dl': 'Tải về',
  'fv.mn.file.share': 'Chia sẻ',
  'fv.mn.file.link': 'Chép link',
  'fv.mn.file.swap': 'Thay tệp',
  'fv.mn.file.del': 'Xoá',
  'fv.mn.send.mail': 'Gửi email',
  'fv.mn.send.attach': 'Gắn vào job khác',
  'fv.mn.send.print': 'In',
  'fv.mn.pdf.editor': 'Mở PDF Editor',
  'fv.mn.pdf.order': 'Sắp xếp trang',
  'fv.mn.pdf.merge': 'Gộp tệp',
  'fv.mn.pdf.sign': 'Ký / đóng dấu',
  'fv.mn.pdf.extract': 'Trích chữ',
  'fv.mn.job.open': 'Mở chi tiết job',
  'fv.mn.job.attach': 'Gắn vào job khác',
  'fv.mn.job.task': 'Tạo việc',
  'fv.infoPanel': 'Bảng thông tin',
  'fv.fileInfo': 'Thông tin tệp',
  'fv.galSub': '18/Oct/2026 · Cảng Cát Lái · {n} ảnh',
  'fv.otherFiles': 'Tệp khác của job ({n})',
  'fv.fromMail': 'Đính kèm từ thư',
  'fv.notSaved': 'Chưa lưu vào job — lưu từ menu Chứng từ.',
  'fv.openMail': 'Mở thư',
  'fv.pagesRange': 'Trang 1–{n} / {n}',
  'fv.zoomOut': 'Thu nhỏ',
  'fv.zoomIn': 'Phóng to',
  'fv.fit': 'Vừa khung',
  'fv.rotate': 'Xoay ảnh',
  'fv.rotateS': 'Xoay',
  'fv.nopermT': 'Bạn chưa có quyền xem tệp này',
  'fv.goneT': 'Tệp không còn nữa',
  'fv.errD': 'Kết nối OneDrive bị gián đoạn. Thử tải lại.',
  'fv.nopermD': 'Chỉ người trong job hoặc được chia sẻ mới xem được.',
  'fv.goneD': 'Tệp đã bị xoá hoặc chuyển đi.',
  'fv.reload': 'Tải lại',
  'fv.readsFile': 'HANA đọc tệp này',
  'fv.askAbout': 'Hỏi HANA về tệp',
  'fv.askPh': 'Hỏi về tệp này…',
  'fv.ask': 'Hỏi',
  'fv.pdfLayer': 'lớp chữ PDF · {n} trang',
  'fv.ocrLang': 'OCR · tiếng Anh + số',
  'fv.copyS': 'Chép',
  'fv.dlTxt': 'Đã tải {f}',
  'fv.dlTxtS': 'Tải .txt',
  'fv.askExtract': 'Đọc phần chữ vừa trích',
  'fv.notRun': 'Chưa chạy. Chọn Tệp ▾ › {how}.',
  'fv.run': 'Chạy {how}',
});
addMessages('en', {
  'fv.cancel': 'Cancel',
  'fv.signBar': 'Sign / stamp · page {n}',
  'fv.signApply': 'Apply signature',
  'fv.signPosOf': 'Position of {x}',
  'fv.signSurr': 'SURRENDERED stamp',
  'fv.signSig': 'signature',
  'fv.signDir': 'Director · PHILIP',
  'fv.signedOn': 'signed 22/10/2026',
  'fv.rightCol': 'Right column',
  'fv.signTitle': 'Sign / stamp PDF',
  'fv.signKind': 'Signature type',
  'fv.sg.mine.l': 'My signature',
  'fv.sg.mine.v': 'Signature image stored on this device · tap to sign',
  'fv.sg.ceo.l': 'Company seal + Director signature',
  'fv.sg.ceo.v': 'By granted permission · logged',
  'fv.sg.surr.l': 'SURRENDERED stamp',
  'fv.sg.surr.v': 'For surrendered B/L · created on the spot',
  'fv.sigSwapped': 'Signature image replaced · stored on this device',
  'fv.sigSwap': 'Change signature image · white background removed',
  'fv.page': 'Page',
  'fv.position': 'Position',
  'fv.pos.tl': 'Top left',
  'fv.pos.tc': 'Top center',
  'fv.pos.tr': 'Top right',
  'fv.pos.bl': 'Bottom left',
  'fv.pos.bc': 'Bottom center',
  'fv.pos.br': 'Bottom right',
  'fv.size': 'Size',
  'fv.sizeSig': 'Signature size',
  'fv.saveOut': 'Saves as ',
  'fv.saveBeside': ' next to the original.',
  'fv.saveKeep': ' The original is unchanged.',
  'fv.pg.bc': 'Booking confirmation',
  'fv.pg.er': 'Empty release order',
  'fv.pg.terms': 'Terms',
  'fv.pg.si': 'SI',
  'fv.pg.cont': 'Container',
  'fv.pg.remarks': 'Remarks',
  'fv.pg.cancel': 'Cancellation notice',
  'fv.pg.mImg': 'Merged image',
  'fv.pg.mDrop': 'Drop-off order',
  'fv.defText': 'Checked · PhuongHT 22/10',
  'fv.edBar': 'PDF Editor · {n} changes',
  'fv.undo': 'Undo',
  'fv.edCancel': 'Discard edits',
  'fv.edSave': 'Save edited copy',
  'fv.leaveT': 'Discard {n} unsaved changes?',
  'fv.keepEd': 'Keep editing',
  'fv.discard': 'Discard changes',
  'fv.leaveD': 'Page changes not yet saved to a file will be lost. The original is not affected.',
  'fv.tool.rl': 'Rotate left',
  'fv.tool.rr': 'Rotate right',
  'fv.tool.del': 'Delete page',
  'fv.tool.up': 'Up',
  'fv.tool.down': 'Down',
  'fv.tool.split': 'Split selected',
  'fv.tool.merge': 'Merge files',
  'fv.tool.text': 'Add text',
  'fv.tool.redact': 'Redact',
  'fv.op.rl': 'Rotate left page {p}',
  'fv.op.rr': 'Rotate right page {p}',
  'fv.op.del': 'Delete page {p}',
  'fv.op.up': 'Move page {p} up',
  'fv.op.down': 'Move page {p} down',
  'fv.op.split': 'Split page {p} into {f} next to the original',
  'fv.op.redact': 'Redact information on page {p}',
  'fv.op.text': 'Add text “{v}” to page {p}',
  'fv.op.merge': 'Append {n} more files',
  'fv.pdfTools': 'PDF tools',
  'fv.hintSel': 'Selected page {p} · tap a page to select / deselect',
  'fv.hintNone': 'Tap pages to select (multi-select) then pick a tool.',
  'fv.textIn': 'Add text to page {p}',
  'fv.textVal': 'Text to add',
  'fv.insert': 'Add',
  'fv.pageOf': 'Page {n} · {k}',
  'fv.merged': 'merged',
  'fv.pending': 'Pending changes',
  'fv.noChange': 'No changes yet. Select pages, then use a tool above.',
  'fv.backFiles': 'Back to file list',
  'fv.loading': 'Loading file…',
  'fv.errT': 'Cannot open file',
  'fv.errPhone': 'Download it to open in an app.',
  'fv.nopermPhone': 'No permission to view this job’s documents.',
  'fv.phAsk': 'HANA: SI cut-off today 16:00, CY 23/Oct 11:00',
  'fv.askHana': 'Ask HANA',
  'fv.extract': 'Extract text',
  'fv.copied': 'Copied {n} lines',
  'fv.copy': 'Copy',
  'fv.m.file': 'File',
  'fv.m.send': 'Send',
  'fv.m.pdf': 'PDF',
  'fv.mi.dl': 'Download',
  'fv.mi.share': 'Share',
  'fv.mi.link': 'Copy link',
  'fv.mi.print': 'Print',
  'fv.mi.del': 'Delete',
  'fv.mi.mailCust': 'Email customer',
  'fv.mi.relBkg': 'Release BKG to customer',
  'fv.mi.sign': 'Sign / stamp',
  'fv.mi.pgOps': 'Rotate, delete, reorder, split, merge pages',
  'fv.mi.txtOps': 'Add text, redact',
  'fv.mi.ipad': 'on iPad / desktop',
  'fv.pageN': 'Page {n}',
  'fv.pageFoot': '{name} · page {no}/{total}',
  'fv.savedEd': 'Saved {f} next to the original · {n} changes',
  'fv.savedSign': 'Saved {f} · {x} page {p}',
  'fv.signCeo': 'seal + Director signature',
  'fv.signDavid': 'DAVID signature',
  'fv.ocrImg': 'Image OCR',
  'fv.file': 'File',
  'fv.nPhotos': '{a}/{b} photos',
  'fv.photo': 'Photo',
  'fv.uploader': 'Uploaded by',
  'fv.type': 'Type',
  'fv.uploadedAt': 'Uploaded {at}',
  'fv.uploaderS': 'Uploader',
  'fv.aiScore': 'AI score',
  'fv.typeDoc': 'Type (TypeDoc)',
  'fv.upload': 'Uploaded',
  'fv.savedAt': 'Stored in',
  'fv.inMail': 'Not saved · in email',
  'fv.jobLib': 'Job document library',
  'fv.noDelete': 'Protected',
  'fv.yesDND': 'Yes (DonotDelete)',
  'fv.no': 'No',
  'fv.backAlbum': 'Back to album',
  'fv.backMail': 'Back to email',
  'fv.backJob': 'Back to job details',
  'fv.ptiAlt': 'PTI photo of container WHLU 5523018',
  'fv.prev': 'Previous photo',
  'fv.next': 'Next photo',
  'fv.film': 'Photo strip',
  'fv.renameT': 'Rename file',
  'fv.saveName': 'Save name',
  'fv.fileName': 'File name',
  'fv.mailT': 'Send file by email',
  'fv.mailFrom': 'Sent from mailbox {m}',
  'fv.send': 'Send',
  'fv.to': 'To',
  'fv.toReq': 'Enter a recipient',
  'fv.subject': 'Subject',
  'fv.body': 'Message',
  'fv.mailBody': 'Dear all,\nHANA is sending the attached file for shipment {j}.\nBest regards,\nDAVID · HANA Logistics',
  'fv.mergeT': 'Append files',
  'fv.mergeD': 'PDF or PNG / JPG image (an image becomes one fitted A4 page)',
  'fv.mergeN': 'Merge {n} files',
  'fv.mgPti': 'PTI photo · from HANA Mov',
  'fv.mgDrop': 'Drop-off order · job file',
  'fv.pickLocal': 'Choose file from device…',
  'fv.viewing': 'Viewing {f}',
  'fv.g.file': 'File',
  'fv.g.send': 'Send',
  'fv.g.pdf': 'PDF',
  'fv.g.job': 'Job',
  'fv.mn.file.rename': 'Rename',
  'fv.mn.file.dl': 'Download',
  'fv.mn.file.share': 'Share',
  'fv.mn.file.link': 'Copy link',
  'fv.mn.file.swap': 'Replace file',
  'fv.mn.file.del': 'Delete',
  'fv.mn.send.mail': 'Send email',
  'fv.mn.send.attach': 'Attach to another job',
  'fv.mn.send.print': 'Print',
  'fv.mn.pdf.editor': 'Open PDF Editor',
  'fv.mn.pdf.order': 'Reorder pages',
  'fv.mn.pdf.merge': 'Merge files',
  'fv.mn.pdf.sign': 'Sign / stamp',
  'fv.mn.pdf.extract': 'Extract text',
  'fv.mn.job.open': 'Open job details',
  'fv.mn.job.attach': 'Attach to another job',
  'fv.mn.job.task': 'Create task',
  'fv.infoPanel': 'Info panel',
  'fv.fileInfo': 'File information',
  'fv.galSub': '18/Oct/2026 · Cat Lai port · {n} photos',
  'fv.otherFiles': 'Other files in job ({n})',
  'fv.fromMail': 'Attachment from email',
  'fv.notSaved': 'Not saved to the job — save from the Documents menu.',
  'fv.openMail': 'Open email',
  'fv.pagesRange': 'Pages 1–{n} / {n}',
  'fv.zoomOut': 'Zoom out',
  'fv.zoomIn': 'Zoom in',
  'fv.fit': 'Fit',
  'fv.rotate': 'Rotate image',
  'fv.rotateS': 'Rotate',
  'fv.nopermT': 'You do not have permission to view this file',
  'fv.goneT': 'File no longer exists',
  'fv.errD': 'OneDrive connection interrupted. Try reloading.',
  'fv.nopermD': 'Only people on the job or with a share can view it.',
  'fv.goneD': 'The file was deleted or moved.',
  'fv.reload': 'Reload',
  'fv.readsFile': 'HANA reads this file',
  'fv.askAbout': 'Ask HANA about the file',
  'fv.askPh': 'Ask about this file…',
  'fv.ask': 'Ask',
  'fv.pdfLayer': 'PDF text layer · {n} pages',
  'fv.ocrLang': 'OCR · English + digits',
  'fv.copyS': 'Copy',
  'fv.dlTxt': 'Downloaded {f}',
  'fv.dlTxtS': 'Download .txt',
  'fv.askExtract': 'Read the extracted text',
  'fv.notRun': 'Not run yet. Choose File ▾ › {how}.',
  'fv.run': 'Run {how}',
});
